function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.4 62.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.15,1.38c-.97,1.17-1.26,4.84-1.08,13.74.23,11.64.08,12.66-3.65,24.63C1.03,47.4-.27,53.3.05,54.97c1,5.26,7.56,8.22,12.42,5.61,1.52-.81,2.82-.69,5.33.5,4.63,2.2,7.22,1.97,10.07-.88,2.75-2.75,3.35-9.19,1.32-14.23-.66-1.64-1.18-9.52-1.25-18.82-.11-15.65-.18-16.11-2.99-21.19C21.92.51,19.88-1.03,17.86.64c-.67.56-1.5.72-1.85.38-.35-.35-1.32-.06-2.16.63-.87.72-1.52.83-1.52.25,0-1.81-2.82-2.15-4.18-.51",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.95,12.1c1.35,4.01,1.54,7.08,1.01,16.43-.36,6.32-.76,11.6-.89,11.72-.13.12-2.71-.19-5.74-.69-3.03-.5-7.19-.64-9.25-.31-4.3.69-4.32.63-2.07-6.64,1.25-4.04,1.61-8.44,1.43-17.18-.14-6.46.02-11.75.35-11.75,1.08,0,2.57,5.14,3.58,12.37,1.13,8.06,2.73,13.63,3.92,13.63,2.75,0,4.39-13.51,2.78-23l-.76-4.5,1.99,2.5c1.09,1.38,2.74,4.72,3.65,7.44",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.45,6.74c1.06,3.79,1.02,17.47-.05,16.38-.82-.84-3.07-14.13-3.07-18.11,0-2.32,2.36-1.01,3.12,1.73",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.78,42.54c2.44.52,3.2,1.42,4.39,5.26,1.73,5.57.98,9.29-2.31,11.44-2.28,1.5-2.7,1.46-6.38-.61-3.7-2.08-4.08-2.11-6.26-.59-3.09,2.16-5.45,2.05-7.88-.37-3.29-3.29-1.84-12.81,2.25-14.78,2.43-1.17,11.45-1.37,16.2-.35",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.747de1fcc489f03afd8fe91e0dea215e.svg";
export { ForwardRef as ReactComponent };